import classNames from "classnames"
import { useTranslation } from "react-i18next"
import { assertUnreachable } from "~/app/utils/typeUtils"
import { EmploymentTemplateStatus } from "@oysterhr/schema"

export const StatusTag = ({ status }: { status: EmploymentTemplateStatus }) => {
  const { t } = useTranslation("hiring_templates/Common")
  const sharedClassName = "rounded-md p-2 text-xs"
  switch (status) {
    case EmploymentTemplateStatus.Active:
      return (
        <div
          className={classNames(sharedClassName, "bg-primary-lighten-100 text-success-darken-100")}
        >
          {t("status.active")}
        </div>
      )
    case EmploymentTemplateStatus.Draft:
      return (
        <div className={classNames(sharedClassName, "bg-gray-100 text-gray-400")}>
          {t("status.draft")}
        </div>
      )

    default:
      return assertUnreachable(status)
  }
}
